import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Boothtypeservice {
  private baseURL: string;
  constructor(private http: HttpClient) {
    this.baseURL = environment.apiBaseUrl;
  }

  GetAllRevenueCategories(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/RevenueCategory/GetAllRevenueCategories`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }


  GetAllBoothTypes(): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/BoothType/GetAllBoothTypes`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  DeleteBoothType(Id: number): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/BoothType/DeleteBoothType?BoothTypeID=${Id}`;
    return this.http.post<any>(url, {}, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  SaveOrUpdateBoothType(BoothType: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/BoothType/SaveOrUpdateBoothType`;
    return this.http.post<any>(url, BoothType, options)
      .pipe(
        map(res => {
          const response = res as any[];
          return response;
        }),
        catchError(this.handleError)
      );
  }

  UpdateOrSaveRentalCharges(data: any, boothtypeId: number): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/BoothType/SaveAllRentalCharges?boothtypeId=${boothtypeId}`;
    return this.http.post<any>(url, data, options)
      .pipe(
        map(res => res),
        catchError(this.handleError)
      );
  }
  GetDailyRentalChargesForABoothType(selectedBoothTypeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/BoothType/GetDailyRentalCharges?BoothTypeId=${selectedBoothTypeId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }
  GetCombinedWeeklyRentalChargesForABoothType(selectedBoothTypeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/BoothType/GetCombinedWeeklyRentalCharges?BoothTypeId=${selectedBoothTypeId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetCombinedMonthlyRentalChargesForABoothType(selectedBoothTypeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/BoothType/GetCombinedMonthlyRentalCharges?BoothTypeId=${selectedBoothTypeId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  GetBoothsByPart(partId: number): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/BoothType/GetBoothsByPart?partId=${partId}`,
      { observe: 'response' }
    ).pipe(
      map(res => {
        const result = res.body as any;
        return result;
      }),
      catchError(this.handleError)
    );
  }

  SaveOrUpdateBoothMaintenance(boothMaintenance: any): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/BoothType/SaveOrUpdateBoothMaintenance`;
    return this.http.post<any>(url, boothMaintenance, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  DeleteBoothMaintenance(boothTypeId: number): Observable<any> {

    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/BoothType/DeleteBoothMaintenance?boothTypeId=${boothTypeId}`;
    return this.http.post<any>(url, {}, options)
      .pipe(
        map(res => {
          const result = res as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }
}